export const Voices = {
  ALLOY: 'ALLOY',
  ECHO: 'ECHO',
  FABLE: 'FABLE',
  NOVA: 'NOVA',
  ONYX: 'ONYX',
  SHIMMER: 'SHIMMER'
};
export const DetailsByVoice = {
  [Voices.ALLOY]: {
    tags: ['us', 'engaging']
  },
  [Voices.ECHO]: {
    tags: ['us', 'engaging']
  },
  [Voices.FABLE]: {
    tags: ['gb', 'conversational']
  },
  [Voices.NOVA]: {
    tags: ['gb', 'conversational']
  },
  [Voices.ONYX]: {
    tags: ['gb', 'professional']
  },
  [Voices.SHIMMER]: {
    tags: ['us', 'professional']
  }
};